

















import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';
import {red, blue} from "@/utils/colors";
import {Dashboard} from "@/services/BackendProxies";
import * as _ from "lodash";

@Component({components: {}})
export default class PCTroskoviPoGrupama extends Vue {
    @Prop() dashboard!: Dashboard;
    godine = [];
    data = {
        labels: [],
        datasets: []
    };
    godina = 0;

    @Watch('dashboard')
    onDashboardChanged(dashboard: Dashboard) {
        this.godine = _.keys(dashboard.troskoviOdrzavanjaPoGrupama).sort((a, b) => -a.localeCompare(b));
        if (this.godine.length) {
            this.godina = this.godine[0];
        }
    }

    @Watch('godina') onGodinaChanged(godina) {
        const troskovi = this.dashboard.troskoviOdrzavanjaPoGrupama[godina];
        const labels = [];
        const preventive = [];
        const corrective = [];
        troskovi.forEach(x => {
           labels.push(x.naziv);
           if (x.preventivno) {
               preventive.push(x.iznos);
               corrective.push(0);
           } else {
               corrective.push(x.iznos);
               preventive.push(0);
           }
        });
        this.data = {
            labels: labels,
            datasets: [
                {label: this.$i18n.t('preventive'), backgroundColor: blue, data: preventive},
                {label: this.$i18n.t('corrective'), backgroundColor: red, data: corrective},
            ]
        }
    }
}
